export const oldStandardRubrics = [
	{
		name: "Beskrivande text",
		custom: true,
		grade: "åk9",
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2024-10-13T13:33:58.000Z"),
		criteria: [
			{
				name: "Beskrivning",
				descriptors: [
					{
						grade: "A",
						text: "Mycket detaljerad och levande beskrivning som engagerar läsaren.",
					},
					{
						grade: "C",
						text: "Tydlig beskrivning med vissa detaljer, men saknar djup.",
					},
					{
						grade: "E",
						text: "Grundläggande beskrivning, men många detaljer saknas.",
					},
					{
						grade: "F",
						text: "Ingen eller mycket svag beskrivning.",
					},
				],
			},
			{
				name: "Struktur",
				descriptors: [
					{
						grade: "A",
						text: "Logisk och tydlig struktur med effektiva övergångar.",
					},
					{
						grade: "C",
						text: "Strukturen finns, men är delvis otydlig.",
					},
					{
						grade: "E",
						text: "Acceptabel struktur, men flera delar är svåra att följa.",
					},
					{
						grade: "F",
						text: "Oorganiserad och svår att följa; ingen tydlig linje.",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "Välutvecklat språk och stil som skapar en stark atmosfär.",
					},
					{
						grade: "C",
						text: "Bra språk med vissa språkliga fel som påverkar flytet något.",
					},
					{
						grade: "E",
						text: "Enkelt språk som är begripligt men har flera språkliga fel.",
					},
					{
						grade: "F",
						text: "Många språkliga fel som försvårar förståelsen.",
					},
				],
			},
			{
				name: "Sinne och känsla",
				descriptors: [
					{
						grade: "A",
						text: "Effektiv användning av sensoriska detaljer som skapar starka känslor.",
					},
					{
						grade: "C",
						text: "Viss användning av sensoriska detaljer, men det känns inte helt engagerande.",
					},
					{
						grade: "E",
						text: "Få sensoriska detaljer som ger en svag känsla.",
					},
					{
						grade: "F",
						text: "Ingen användning av sensoriska detaljer eller känslor.",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		custom: true,
		grade: "åk9",
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2024-10-12T14:12:54.000Z"),
		criteria: [
			{
				name: "Argumentation",
				descriptors: [
					{
						grade: "A",
						text: "Starka, väl underbyggda argument som övertygar läsaren. Motargument bemöts effektivt.",
					},
					{
						grade: "C",
						text: "Tydlig argumentation med stödjande exempel, men vissa argument kan utvecklas mer.",
					},
					{
						grade: "E",
						text: "Grundläggande argumentation, men vissa argument är svaga eller saknar stöd.",
					},
					{
						grade: "F",
						text: "Bristfälliga eller frånvarande argument. Ingen tydlig linje i resonemanget.",
					},
				],
			},
			{
				name: "Disposition",
				descriptors: [
					{
						grade: "A",
						text: "Logisk och tydlig struktur med starka övergångar mellan idéer.",
					},
					{
						grade: "C",
						text: "Struktur finns, men vissa övergångar är otydliga.",
					},
					{
						grade: "E",
						text: "Acceptabel struktur, men vissa avsnitt är svåra att följa.",
					},
					{
						grade: "F",
						text: "Oorganiserad och svår att följa; ingen tydlig inledning, kropp eller avslutning.",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "Välutvecklat språk, stilistiskt övertygande och engagerande.",
					},
					{
						grade: "C",
						text: "Bra språk med några mindre språkliga fel.",
					},
					{
						grade: "E",
						text: "Enkelt men begripligt språk med några fel som påverkar flytet.",
					},
					{
						grade: "F",
						text: "Många språkliga fel som försvårar förståelsen.",
					},
				],
			},
			{
				name: "Källhantering",
				descriptors: [
					{
						grade: "A",
						text: "Effektiv och korrekt användning av källor som stärker argumenten.",
					},
					{
						grade: "C",
						text: "Källor används, men vissa är tveksamma eller saknas.",
					},
					{
						grade: "E",
						text: "Grundläggande användning av källor, men vissa referenser saknas eller är felaktiga.",
					},
					{
						grade: "F",
						text: "Ingen eller felaktig användning av källor.",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		custom: true,
		grade: "åk9",
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2024-10-13T13:34:34.000Z"),
		criteria: [
			{
				name: "Handlingsutveckling",
				descriptors: [
					{
						grade: "A",
						text: "Engagerande och välutvecklad handling som fångar läsarens intresse.",
					},
					{
						grade: "C",
						text: "Tydlig handling, men vissa delar kunde utvecklas mer.",
					},
					{
						grade: "E",
						text: "Enkel handling som saknar djup och intresse.",
					},
					{
						grade: "F",
						text: "Ingen eller mycket svag handling.",
					},
				],
			},
			{
				name: "Karaktärsutveckling",
				descriptors: [
					{
						grade: "A",
						text: "Välutvecklade karaktärer med tydlig motivation och bakgrund.",
					},
					{
						grade: "C",
						text: "Tydliga karaktärer, men vissa motiv är oklara.",
					},
					{
						grade: "E",
						text: "Grundläggande karaktärer som saknar djup.",
					},
					{
						grade: "F",
						text: "Ingen eller mycket svag karaktärsutveckling.",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "Engagerande språk och stil som förstärker berättelsen.",
					},
					{
						grade: "C",
						text: "Bra språk med vissa språkliga fel.",
					},
					{
						grade: "E",
						text: "Enkelt men begripligt språk med några fel som påverkar flytet.",
					},
					{
						grade: "F",
						text: "Många språkliga fel som försvårar förståelsen.",
					},
				],
			},
			{
				name: "Struktur",
				descriptors: [
					{
						grade: "A",
						text: "Tydlig och logisk struktur med starka övergångar.",
					},
					{
						grade: "C",
						text: "Struktur finns, men vissa övergångar är otydliga.",
					},
					{
						grade: "E",
						text: "Acceptabel struktur, men vissa avsnitt är svåra att följa.",
					},
					{
						grade: "F",
						text: "Oorganiserad och svår att följa; ingen tydlig linje.",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		custom: true,
		grade: "åk9",
		formativeComments: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:05.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "Kristallklara instruktioner med exakt och precis information. Inga oklarheter.",
					},
					{
						grade: "C",
						text: "Tydliga instruktioner med få oklarheter som inte påverkar förståelsen.",
					},
					{
						grade: "E",
						text: "Grundläggande instruktioner som kan följas, men med vissa oklarheter.",
					},
					{
						grade: "F",
						text: "Otydliga eller förvirrande instruktioner som är svåra att följa.",
					},
				],
			},
			{
				name: "Struktur och ordning",
				descriptors: [
					{
						grade: "A",
						text: "Perfekt logisk ordningsföljd med tydliga steg och delmoment.",
					},
					{
						grade: "C",
						text: "Bra struktur men vissa steg kunde vara tydligare ordnade.",
					},
					{
						grade: "E",
						text: "Acceptabel ordning men vissa steg är otydligt placerade.",
					},
					{
						grade: "F",
						text: "Ologisk ordning som gör instruktionerna omöjliga att följa.",
					},
				],
			},
			{
				name: "Språk och terminologi",
				descriptors: [
					{
						grade: "A",
						text: "Konsekvent och korrekt användning av relevant terminologi.",
					},
					{
						grade: "C",
						text: "Mestadels korrekt terminologi med några mindre felaktigheter.",
					},
					{
						grade: "E",
						text: "Enkel men förståelig terminologi med vissa brister.",
					},
					{
						grade: "F",
						text: "Felaktig eller förvirrande användning av termer.",
					},
				],
			},
			{
				name: "Visuella hjälpmedel",
				descriptors: [
					{
						grade: "A",
						text: "Effektiv användning av bilder/diagram som förstärker instruktionerna.",
					},
					{
						grade: "C",
						text: "Bilder/diagram används men kunde vara mer effektiva.",
					},
					{
						grade: "E",
						text: "Grundläggande visuella hjälpmedel som delvis stödjer texten.",
					},
					{
						grade: "F",
						text: "Inga eller missvisande visuella hjälpmedel.",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		custom: true,
		grade: "åk9",
		formativeComments: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:52.000Z"),
		criteria: [
			{
				name: "Innehåll och relevans",
				descriptors: [
					{
						grade: "A",
						text: "Omfattande och relevant information som täcker ämnet fullständigt.",
					},
					{
						grade: "C",
						text: "God informationsmängd men vissa aspekter kunde utvecklas.",
					},
					{
						grade: "E",
						text: "Grundläggande information men flera viktiga delar saknas.",
					},
					{
						grade: "F",
						text: "Bristfällig eller irrelevant information.",
					},
				],
			},
			{
				name: "Källhantering",
				descriptors: [
					{
						grade: "A",
						text: "Utmärkt källkritik och korrekt referering till trovärdiga källor.",
					},
					{
						grade: "C",
						text: "God källhantering men vissa referenser kunde förbättras.",
					},
					{
						grade: "E",
						text: "Enkel källhantering med vissa brister i referering.",
					},
					{
						grade: "F",
						text: "Undermålig eller ingen källhantering.",
					},
				],
			},
			{
				name: "Objektivitet och saklighet",
				descriptors: [
					{
						grade: "A",
						text: "Konsekvent objektivt och sakligt presenterad information.",
					},
					{
						grade: "C",
						text: "Mestadels saklig men med vissa subjektiva inslag.",
					},
					{
						grade: "E",
						text: "Grundläggande saklighet men flera subjektiva värderingar.",
					},
					{
						grade: "F",
						text: "Mycket subjektiv eller missvisande presentation.",
					},
				],
			},
			{
				name: "Struktur och presentation",
				descriptors: [
					{
						grade: "A",
						text: "Logisk struktur som effektivt förmedlar informationen.",
					},
					{
						grade: "C",
						text: "Tydlig struktur men vissa delar kunde organiseras bättre.",
					},
					{
						grade: "E",
						text: "Grundläggande struktur men ibland svår att följa.",
					},
					{
						grade: "F",
						text: "Oorganiserad och svår att förstå.",
					},
				],
			},
		],
	},
];
